<template>
<div class="header-page">
    <div class="header-swiper">
      <div class="header-navbar-logo" v-if="isSmallScreen===false" @click="toplogo">
        <img src="@/assets/2023logoImage/top-logo.png" alt="">
      </div>
       <div class="header-navbar-logo" v-else @click="toplogo">
        <img src="@/assets/2023logoImage/logo-t.png" alt="">
      </div>
      <!-- pc端 -->
      <div class="header-navbar-size" v-if="isSmallScreen===false">
        <span class="header-navbar-size-shouye1" @click="shouye">首页</span>
        <span class="header-navbar-size-shouye2" @mouseover='onMouseover' >
          产品
        </span>
        <img class="xiajiantou" src="../../../assets/2023logoImage/xxjt.png" alt="">
        <span class="header-navbar-size-shouye3" @click="Contact">联系我们</span>
      </div>
      <!-- 移动端 -->
     <div class="header-navbar-er" v-else >
        <!-- <img class="ys" @click="Contact" src="../../../assets/2023logoImage/ys.png" alt=""> -->
        <div class="header-yuyues" @click="Contact">
          <p class="header-yanshis">预约演示</p>
        </div>
        <img class="hb" @click="naviga" src="../../../assets/iconfont/hbtb1.png" alt="">
      </div>
      <div class="header-tuoyuan" v-if="isSmallScreen===false">
        <img class="header-iphone" src="../../../assets/2023logoImage/iphone-loukong.png" alt="">
        <p class="header-shoujihao">+86 400-638-5060</p>
      </div>
      <div class="header-yuyue" v-if="isSmallScreen===false" @click="Contact">
        <p class="header-yanshi">预约演示</p>
      </div>
      <div class="header-navbar-dis" @mouseout="onMouseEnter" @mouseover='onMouseover'>
        <ul>
          <li class="li1" @click="kong">碳立方-企业零碳大脑-控排行业版</li>
          <li class="li2" @click="zuji">碳立方-企业零碳大脑-碳足迹版</li>
          <li class="li3" @click="danao">碳立方-城市零碳大脑</li>
          <li class="li4" @click="yuanqu">碳立方-园区零碳大脑</li>
          <li class="li5" @click="dian">碳立方-绿色减碳-新能源电站</li>
          <li class="li6" @click="linye">碳立方-绿色减碳-林业碳汇</li>
          <li class="li7" @click="youshi">碳立方-碳立方的优势</li>
        </ul>
      </div>
      <div class="header-navbar"></div>
      <!-- @changeSwiper='changeSwiper' @addSwiper='addSwiper' -->
      <swiper></swiper>
                  <div class="swiperss"></div>
                  <div class="swipersst"></div>
        <el-drawer
          ref="myDrawer"
          title=""
          size="80%"
          :visible.sync="drawer"
          :direction="direction"
          :before-close="handlenavbar">
            <div class="drawers-lo">
              <div class="ssy1"></div><span class="shouye" @click="shouye">首页</span>
               <span class="chanpin"  @click='lookSmall' >
                产品
                </span>
                <!-- 隐藏 -->
              <div class="ssy2"></div><span class="jia" v-if="flex % 2 !== 0">
                  +
                </span>
                <!-- 显示 -->
               <div class="ssy3"></div> <span class="jian" v-if="flex % 2 === 0">
                  -
                </span>
                <ul class="tan">
                 <span class="span1">></span> <li class="li1" @click="kong">碳立方-企业零碳大脑-控排行业版</li>
                 <span class="span2">></span> <li class="li2" @click="zuji">碳立方-企业零碳大脑-碳足迹版</li>
                 <span class="span3">></span> <li class="li3" @click="danao">碳立方-城市零碳大脑</li>
                 <span class="span4">></span> <li class="li4" @click="yuanqu">碳立方-园区零碳大脑</li>
                 <span class="span5">></span> <li class="li5" @click="dian">碳立方-绿色减碳-新能源电站</li>
                 <span class="span6">></span> <li class="li6" @click="linye">碳立方-绿色减碳-林业碳汇</li>
                 <span class="span7">></span> <li class="li7" @click="youshi"> 碳立方-碳立方的优势</li>
                  </ul>
              <div class="ssy3"></div> <span class="lianxi" @click="Contact">联系我们</span>
            </div>
      </el-drawer>
      </div>
</div>
</template>
<script>
import swiper from '@/components/swiper'
export default {
  components: { swiper },
  name: 'Header',
  data () {
    return {
      currentLefp: 316,
      currentLeftt: 344,
      currentLeftr: 344,
      currentLefts: 376,
      currentLeft: 276,
      currentlitleLeft: 18,
      swiperOption: {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      flex: 1,
      drawer: false,
      direction: 'ltr',
      isSmallScreen: false,
      dialogVisible: false
      // currentRoute: ''
    }
  },
  mounted () {
    // this.currentRoute = this.$route.path
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      document.querySelector('.swipersst').style.left = '18px'
      const bodyWidth = document.querySelector('body').offsetWidth
      const swipersst = document.querySelector('.swipersst')
      if (bodyWidth > 1900) {
        swipersst.style.left = '376px'
      } else if (bodyWidth > 1700 && bodyWidth <= 1900) {
        swipersst.style.left = '344px'
      } else if (bodyWidth > 2000) { // 增加一个额外的判断条件
        swipersst.style.left = '344px'
      }
    } else {
      this.isSmallScreen = false
    }
  },
  methods: {
    // 右滚动
    // changeSwiper () {
    //   // 改变滚动条的位置
    //   if (this.isSmallScreen === false) {
    //     var sw = document.querySelector('.swipersst')
    //     sw.style.left = this.currentLeft + 'px'
    //     this.currentLeft += 40
    //     if (this.currentLeft >= 457) {
    //       this.currentLeft = 276
    //     }
    //   } else {
    //     var sw1 = document.querySelector('.swipersst')
    //     sw1.style.left = this.currentlitleLeft + 'px'
    //     this.currentlitleLeft += 20
    //     if (this.currentlitleLeft >= 99) {
    //       this.currentlitleLeft = 18
    //     }
    //   }
    //   if (document.querySelector('body').offsetWidth > 1900) {
    //     var sw2 = document.querySelector('.swipersst')
    //     sw2.style.left = this.currentLefts + 'px'
    //     this.currentLefts += 40
    //     if (this.currentLefts >= 557) {
    //       this.currentLefts = 376
    //     }
    //   }
    //   if (document.querySelector('body').offsetWidth > 1700 && document.querySelector('body').offsetWidth <= 1900) {
    //     var sw3 = document.querySelector('.swipersst')
    //     sw3.style.left = this.currentLeftr + 'px'
    //     this.currentLeftr += 40
    //     if (this.currentLeftr >= 505) {
    //       this.currentLeftr = 344
    //     }
    //   }
    //   if (document.querySelector('body').offsetWidth > 1600 && document.querySelector('body').offsetWidth <= 1700) {
    //     var sw4 = document.querySelector('.swipersst')
    //     sw4.style.left = this.currentLefp + 'px'
    //     this.currentLefp += 40
    //     if (this.currentLefp >= 505) {
    //       this.currentLefp = 316
    //     }
    //   }
    // },
    // 左滚动
    // addSwiper () {
    //   if (this.isSmallScreen === false) {
    //     var sw = document.querySelector('.swipersst')
    //     if (document.querySelector('body').offsetWidth > 1900) {
    //       sw.style.left = this.currentLefts + 'px'
    //       this.currentLefts -= 40
    //       if (this.currentLefts <= 375) {
    //         this.currentLefts = 537
    //       }
    //     }
    //     if (document.querySelector('body').offsetWidth > 1400 && document.querySelector('body').offsetWidth < 1600) {
    //       sw.style.left = this.currentLeft + 'px'
    //       this.currentLeft -= 40
    //       if (this.currentLeft <= 275) {
    //         this.currentLeft = 437
    //       }
    //     }
    //     if (document.querySelector('body').offsetWidth > 1600 && document.querySelector('body').offsetWidth <= 1700) {
    //       sw.style.left = this.currentLeft + 'px'
    //       this.currentLeft -= 40
    //       if (this.currentLeft < 316) {
    //         this.currentLeft = 476
    //       }
    //     }
    //   } else {
    //     var sw1 = document.querySelector('.swipersst')
    //     sw1.style.left = this.currentlitleLeft + 'px'
    //     this.currentlitleLeft -= 20
    //     if (this.currentlitleLeft <= 17) {
    //       this.currentlitleLeft = 98
    //     }
    //   }
    // },
    toplogo () {
      this.$router.push('/')
    },
    jian () {
      this.flex = this.flex + 2
      var res = document.querySelectorAll('.tan li')
      res.forEach((item) => {
        item.style.display = 'none'
      })
    },
    naviga () {
      this.drawer = true
    },
    handlenavbar (done) {
      done()
    },
    lookSmall () {
      var str1 = document.querySelector('.span1')
      var str2 = document.querySelector('.span2')
      var str3 = document.querySelector('.span3')
      var str4 = document.querySelector('.span4')
      var str5 = document.querySelector('.span5')
      var str6 = document.querySelector('.span6')
      var str7 = document.querySelector('.span7')
      var res1 = document.querySelector('.chanpin')
      var res = document.querySelectorAll('.tan li')
      var elements = document.querySelectorAll('.ssy3')
      var res2 = document.querySelector('.ssy2')
      if (this.flex % 2 !== 0) {
        res1.style.color = '#63c0a0'
        str1.style.display = 'block'
        str2.style.display = 'block'
        str3.style.display = 'block'
        str4.style.display = 'block'
        str5.style.display = 'block'
        str6.style.display = 'block'
        str7.style.display = 'block'
        // #6dc5c6'
        res2.style.backgroundColor = '#63c0a0'
      } else {
        res1.style.color = '#fff'
        str1.style.display = 'none'
        str2.style.display = 'none'
        str3.style.display = 'none'
        str4.style.display = 'none'
        str5.style.display = 'none'
        str6.style.display = 'none'
        str7.style.display = 'none'
        res2.style.backgroundColor = '#313234'
      }
      this.flex++
      res.forEach((item) => {
        item.style.display = this.flex % 2 !== 0 ? 'none' : 'block'
      })
      const topValue = (this.flex % 2 !== 0) ? '214px' : '606px'
      elements.forEach((item) => {
        item.style.top = topValue
      })
    },
    // 鼠标移出
    onMouseEnter () {
      var res = document.querySelector('.header-navbar-dis')
      res.style.display = 'none'
    },
    // 鼠标移入
    onMouseover () {
      var res = document.querySelector('.header-navbar-dis')
      res.style.display = 'block'
    },
    // 首页
    shouye () {
      this.$router.push('/')
    },
    // 空排行业版
    kong () {
      this.$router.push('./product/industryEdition')
    },
    // 碳足迹版本
    zuji () {
      this.$router.push('./product/footprint')
    },
    // 城市零碳大脑
    danao () {
      this.$router.push('/product/brain')
    },
    // 园区零碳大脑
    yuanqu () {
      this.$router.push('/product/park')
    },
    // 新能源电站
    dian () {
      this.$router.push('/product/powerStation')
    },
    // 林业碳汇
    linye () {
      this.$router.push('/product/forestry')
    },
    // 碳立方的优势
    youshi () {
      this.$router.push('/product/advantage')
    },
    // 联系我们
    Contact () {
      this.$router.push('/product/Contact')
    },
    // 关闭弹窗
    handleClose (done) {
      done()
    }
  }

}
</script>

<style scoped lang="scss">
    .swiperss{
            width: 200px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 276px;
            top: 657px;
            z-index: 1999;
        }
        .swipersst{
            width: 40px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 276px;
            top: 657px;
            z-index: 1999;
        }
        .xiajiantou{
          position: absolute;
          left: 130px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
          // filter: drop-shadow(2px 0px #fff);
        }
.header-navbar{
  width: 100%;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 899;
}
.header-navbar-logo{
  cursor: pointer;
  width: 200px;
  height: 60px;
  position: absolute;
  // left: 253px;
  left: 18%;
  top: 16px;
  z-index: 998;
}

.header-swiper-img{
  width: 100%;
  // height: 100%;
  height: 950px;
}
.header-tuoyuan{
  width: 188px;
  height: 40px;
  border: 1px solid #7abca0;
  z-index: 999;
  position: absolute;
  right: 21%;
  top: 20px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  .header-iphone{
    width: 30px;
    height: 30px;
  }
  .header-shoujihao{
    // margin-left:10px ;
    color: #7abca0;
    font-weight: 600;
  }
}
.header-yuyue{
  cursor: pointer;
  width: 100px;
  height: 40px;
  background-color: #7abca0;
  position: absolute;
  right: 12%;
  top: 20px;
  border: 1px solid #7abca0;
  border-radius: 50px;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  .header-yanshi{
    color: #fff;
  }
}
.header-navbar-er{
  margin-top: 20px;
  font-size: 25px;
  // .ys{
  //   position: absolute;
  //   left: -43px;
  //   top: 50%;
  //   transform: translateY(-50%);
  // }
  .header-yuyues{
    width: 70px;
    height: 28px;
    background-color: #63c0a0;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: -93px;
    top: 50%;
    transform: translateY(-50%);
    border: 1px solid #63c0a0;
    border-radius: 50px;
    .header-yanshis{
      color: #fff;
    }
  }
}
.header-navbar-size{
  position: absolute;
  left: 35%;
  top: 32px;
  color: black;
  font-size: 15px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  text-shadow: gainsboro;
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: black;
}

.header-navbar-size-shouye1:hover{
  border-bottom: 2px solid #6dc6c6;
  color: #7abea2;
}
.header-navbar-size-shouye2:hover{
  border-bottom: 2px solid #6dc6c6;
  color: #7abea2;
}
.header-navbar-size-shouye3:hover{
  border-bottom: 2px solid #6dc6c6;
  color: #7abea2;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  background-color: #fff;
  color: black;
  position: absolute;
  left: 40%;
  top: 90px;
  z-index: 905;
  border-radius:10px ;
  ul li{
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
       cursor: pointer !important;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    color: #7abea2;
  }
  to {
    color: #7abea2;
  }
}
}
@media screen and (max-width: 1351px) and (min-width:1000px) {
          .swiperss{
            width: 200px;
            height: 7px;
            background-color: #b3c677;
            position: absolute;
            left: 276px;
            top: 521px;
            z-index: 1999;
        }
        .swipersst{
            width: 40px;
            height: 7px;
            background-color: #fff;
            position: absolute;
            left: 276px;
            top: 521px;
            z-index: 1999;
        }
}
@media screen and (max-width: 1440px) and (min-width:1350px) {
          .swiperss{
            width: 200px;
            height: 7px;
            background-color: #b3c677;
            position: absolute;
            left: 276px;
            top: 583px;
            z-index: 1999;
        }
        .swipersst{
            width: 40px;
            height: 7px;
            background-color: #fff;
            position: absolute;
            left: 276px;
            top: 583px;
            z-index: 1999;
        }
        .xiajiantou{
          position: absolute;
          left: 130px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
        }
  .header-navbar{
  width: 100%;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 899;
}
.header-navbar-logo{
  width: 200px;
  height: 60px;
  position: absolute;
  left: 18%;
  top: 16px;
  z-index: 998;
}

.header-swiper-img{
  width: 100%;
  // height: 100%;
  height: 950px;
}
.header-navbar-er{
  margin-top: 20px;
  font-size: 25px;
}
.header-navbar-size{
  position: absolute;
  left: 35%;
  top: 32px;
  color: black;
  font-size: 15px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  text-shadow: gainsboro;
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}

.header-navbar-size-shouye1:hover{
  color: #7abca0;
  border-bottom: 2px solid #6dc6c6 ;
}
.header-navbar-size-shouye2:hover{
  color: #7abca0;
  border-bottom: 2px solid #6dc6c6 ;
}
.header-navbar-size-shouye3:hover{
  color: #7abca0;
  border-bottom: 2px solid #6dc6c6 ;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  background-color: #fff;
  color: black;
  position: absolute;
  // left: 35%;
  left: 40%;
  top: 90px;
  z-index: 905;
  border-radius:10px ;
  ul li{
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
       cursor: pointer !important;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    // padding-left: 20px;
    color: #7abea2;
  }
  to {
    // padding-left: 40px;
    color: #7abea2;
  }
}
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: black;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
 .jia{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 96px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 149px;
  }
  .ssy3{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 201px;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .tan .span1{
    color: black;
    position: absolute;
    left: 25px;
    top:195px;
    display: none;
  }
   .tan .span2{
    color: black;
    position: absolute;
    left: 25px;
    top: 248px;
        display: none;
  }
   .tan .span3{
    color: black;
    position: absolute;
    left: 25px;
    top: 298px;
        display: none;
  }
  .tan .span4{
    color: black;
    position: absolute;
    left: 25px;
    top: 346px;
        display: none;
  }
  .tan .span5{
    color: black;
    position: absolute;
    left: 25px;
    top: 396px;
        display: none;
  }
  .tan .span6{
    color: black;
    position: absolute;
    left: 25px;
    top: 446px;
    display: none;
  }
  .tan .span7{
    color: black;
    position: absolute;
    left: 25px;
    top: 496px;
    display: none;
  }
}
  ::v-deep{
  .el-drawer{
      background-color: #1a1b1d !important;
    }
}

}
@media screen and (min-width: 1795px) {
          .swiperss{
            width: 200px;
            height: 7px;
            background-color: #b3c677;
            position: absolute;
            left: 342px;
            top: 566px;
            z-index: 1999;
        }
        .swipersst{
            width: 40px;
            height: 7px;
            background-color: #fff;
            position: absolute;
            left: 342px;
            top: 566px;
            z-index: 1999;
        }
}
@media screen and (max-width: 1800px) and (min-width:1601px) {
          .swiperss{
            width: 200px;
            height: 7px;
            background-color: #b3c677;
            position: absolute;
            left: 316px;
            top: 649px;
            z-index: 1999;
        }
        .swipersst{
            width: 40px;
            height: 7px;
            background-color: #fff;
            position: absolute;
            left: 316px;
            top: 649px;
            z-index: 1999;
        }
        .xiajiantou{
          position: absolute;
          left: 130px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
        }
  .header-navbar{
  width: 100%;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 899;
}
.header-navbar-logo{
  width: 200px;
  height: 60px;
  position: absolute;
  left: 18%;
  top: 14px;
  z-index: 998;
}

.header-swiper-img{
  width: 100%;
  // height: 100%;
  height: 950px;
}
.header-navbar-er{
  margin-top: 20px;
  font-size: 25px;
}
.header-navbar-size{
  position: absolute;
  left: 35%;
  top: 32px;
  color: black;
  font-size: 15px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  text-shadow: gainsboro;
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}

.header-navbar-size-shouye1:hover{
  color: #7abca0;
  border-bottom: 2px solid #6dc6c6 ;
}
.header-navbar-size-shouye2:hover{
  color: #7abca0;
  border-bottom: 2px solid #6dc6c6 ;
}
.header-navbar-size-shouye3:hover{
  color: #7abca0;
  border-bottom: 2px solid #6dc6c6 ;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  background-color: #fff;
  color: black;
  position: absolute;
  // left: 35%;
  left: 40%;
  top: 90px;
  z-index: 905;
  border-radius:10px ;
  ul li{
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
       cursor: pointer !important;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    // padding-left: 20px;
    color: #7abea2;
  }
  to {
    // padding-left: 40px;
    color: #7abea2;
  }
}
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: black;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
 .jia{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 96px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 149px;
  }
  .ssy3{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 201px;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .tan .span1{
    color: black;
    position: absolute;
    left: 25px;
    top:195px;
    display: none;
  }
   .tan .span2{
    color: black;
    position: absolute;
    left: 25px;
    top: 248px;
        display: none;
  }
   .tan .span3{
    color: black;
    position: absolute;
    left: 25px;
    top: 298px;
        display: none;
  }
  .tan .span4{
    color: black;
    position: absolute;
    left: 25px;
    top: 346px;
        display: none;
  }
  .tan .span5{
    color: black;
    position: absolute;
    left: 25px;
    top: 396px;
        display: none;
  }
  .tan .span6{
    color: black;
    position: absolute;
    left: 25px;
    top: 446px;
    display: none;
  }
  .tan .span7{
    color: black;
    position: absolute;
    left: 25px;
    top: 496px;
    display: none;
  }
}
  ::v-deep{
  .el-drawer{
      background-color: #1a1b1d !important;
    }
}

}
@media screen and (max-width: 1900px) and (min-width:1801px) {
          .swiperss{
            width: 200px;
            height: 7px;
            background-color: #b3c677;
            position: absolute;
            left: 316px;
            top: 702px;
            z-index: 1999;
        }
        .swipersst{
            width: 40px;
            height: 7px;
            background-color: #fff;
            position: absolute;
            left: 316px;
            top: 702px;
            z-index: 1999;
        }
}
@media screen and (min-width: 1920px) {
       .swiperss{
            width: 200px;
            height: 7px;
            background-color: #b3c677;
            position: absolute;
            left: 376px;
            // left: 19%;
            top: 760px;
            z-index: 1999;
        }
        .swipersst{
            width: 40px;
            height: 7px;
            background-color: #fff;
            position: absolute;
            left: 376px;
            // left: 19%;
            top: 760px;
            z-index: 1999;
        }
        .xiajiantou{
          position: absolute;
          left: 138px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
          // filter: drop-shadow(2px 0px #fff);
        }
  .header-navbar{
  width: 100%;
  height: 90px;
  // background-color: rgb(23, 21, 21);
  background-color: #fff;
  // opacity: 0.5;
  position: absolute;
  left: 0;
  top: 0;
}
.header-navbar-logo{
  width: 250px;
  height: 60px;
  position: absolute;
  left: 368px;
  top: 10px;
  z-index: 901;
}

.header-swiper-img{
  width: 100%;
  height: 100%;
}
.header-navbar-size{
  position: absolute;
  // right: 20%;
  // right: 45%;
  left: 35%;
  top: 32px;
  color: black;
  font-size: 17px;
  font-weight: 500;
  z-index: 989;
}
.header-navbar-size-shouye1{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}
.header-navbar-size-shouye1:hover{
  border-bottom: 2px solid #69bdbd ;
  color: #7abca0;
}
.header-navbar-size-shouye2:hover{
  border-bottom: 2px solid #69bdbd ;
  color: #7abca0;
}
.header-navbar-size-shouye3:hover{
  border-bottom: 2px solid #69bdbd ;
  color: #7abca0;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  background-color: #fff;
  color: black;
  position: absolute;
  left: 40%;
  top: 90px;
  border-radius:10px ;
  ul li{
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
       cursor: pointer !important;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    color: #7abea2;
  }
  to {
    color: #7abea2;
  }
}
}
}
@media screen and (max-width: 375px) {
       .swiperss{
            width: 100px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 18px;
            top: 278px;
            z-index: 1999;
        }
        .swipersst{
            width: 20px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 18px;
            top: 278px;
            z-index: 1999;
        }
.header-navbar{
  width: 100%;
  height: 58px;
  background-color: #262626;
  position: relative;
  left: 0;
  top: 0;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  background-color: #fff;
  color: white;
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 96px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 149px;
  }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 196px;
        display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 250px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 305px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 360px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 415px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 471px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 526px;
    display: none;
  }
}
}
@media screen and (max-width: 1540px) and (min-width:1441px){
  .swiperss{
            width: 200px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 276px;
            top: 607px;
            z-index: 1999;
        }
        .swipersst{
            width: 40px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 276px;
            top: 607px;
            z-index: 1999;
        }
}
@media screen and (max-width: 1000px) and (min-width:768px){
      .swiperss{
            width: 200px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 276px;
            top: 657px;
            z-index: 1999;
        }
      .swipersst{
            width: 40px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 276px;
            top: 657px;
            z-index: 1999;
        }
      .xiajiantou{
          position: absolute;
          left: 130px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
          // filter: drop-shadow(2px 0px #fff);
        }
.header-navbar{
  width: 100%;
  height: 90px;
  background-color: #262626;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 899;
}
.header-navbar-logo{
  cursor: pointer;
  width: 200px;
  height: 60px;
  position: absolute;
  // left: 253px;
  left: 18%;
  top: 16px;
  z-index: 998;
}

.header-swiper-img{
  width: 100%;
  // height: 100%;
  height: 950px;
}
// .header-tuoyuan{
//   width: 188px;
//   height: 40px;
//   border: 1px solid #7abca0;
//   z-index: 999;
//   position: absolute;
//   right: 21%;
//   top: 20px;
//   border-radius: 50px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   .header-iphone{
//     width: 30px;
//     height: 30px;
//   }
//   .header-shoujihao{
//     margin-left:10px ;
//     color: #7abca0;
//     font-weight: 600;
//   }
// }
// .header-yuyue{
//   cursor: pointer;
//   width: 100px;
//   height: 40px;
//   background-color: #7abca0;
//   position: absolute;
//   right: 12%;
//   top: 20px;
//   border: 1px solid #7abca0;
//   border-radius: 50px;
//   z-index: 999;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   .header-yanshi{
//     color: #fff;
//   }
// }
.header-navbar-er{
  margin-top: 20px;
  font-size: 25px;
  .header-yuyues{
    width: 70px;
    height: 28px;
    background-color: #63c0a0;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: -93px;
    top: 50%;
    transform: translateY(-50%);
    border: 1px solid #63c0a0;
    border-radius: 50px;
    .header-yanshis{
      color: #fff;
    }
  }
}
.header-navbar-size{
  position: absolute;
  left: 35%;
  top: 32px;
  color: black;
  font-size: 15px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  text-shadow: gainsboro;
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: black;
}

.header-navbar-size-shouye1:hover{
  border-bottom: 2px solid #6dc6c6;
  color: #7abea2;
}
.header-navbar-size-shouye2:hover{
  border-bottom: 2px solid #6dc6c6;
  color: #7abea2;
}
.header-navbar-size-shouye3:hover{
  border-bottom: 2px solid #6dc6c6;
  color: #7abea2;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  background-color: #fff;
  color: black;
  position: absolute;
  left: 40%;
  top: 90px;
  z-index: 905;
  border-radius:10px ;
  ul li{
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
       cursor: pointer !important;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    color: #7abea2;
  }
  to {
    color: #7abea2;
  }
}
}
}
@media screen and (max-width: 414px) and (min-width:391px) {
        .swiperss{
            width: 100px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 18px;
            top: 305px;
            z-index: 1999;
        }
        .swipersst{
            width: 20px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 18px;
            top: 305px;
            z-index: 1999;
        }
.header-navbar{
  width: 100%;
  height: 58px;
  background-color: #262626;
  position: relative;
  left: 0;
  top: 0;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  // background-color: rgb(23, 21, 21);
  // opacity: 0.5;
  background-color: #fff;
  color: white;
  position: absolute;
  /* right: 150px; */
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia{
    position: absolute;
    right: 20px;
    top: 144px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 144px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 101px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 154px;
  }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 203px;
        display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 258px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 310px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 365px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 420px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 476px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 531px;
    display: none;
  }
}
}
@media screen and (max-width: 767px) and (min-width:500px) {
        .swiperss{
            width: 100px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 18px;
            top: 366px;
            z-index: 1999;
        }
        .swipersst{
            width: 20px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 18px;
            top: 366px;
            z-index: 1999;
        }
.header-navbar{
  width: 100%;
  height: 58px;
  background-color: #262626;
  position: relative;
  left: 0;
  top: 0;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  background-color: #fff;
  color: white;
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 96px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 149px;
  }
  .ssy3{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 201px;
  }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 196px;
        display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 250px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 305px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 360px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 415px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 471px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 526px;
    display: none;
  }
}
}
@media screen and (max-width: 390px) and (min-width:376px) {
        .swiperss{
            width: 100px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 18px;
            top: 286px;
            z-index: 1999;
        }
        .swipersst{
            width: 20px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 18px;
            top: 286px;
            z-index: 1999;
        }
.header-navbar{
  width: 100%;
  height: 58px;
  background-color: #262626;
  position: relative;
  left: 0;
  top: 0;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  background-color: #fff;
  color: white;
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia,
  .jian{
    position: absolute;
    right: 20px;
    top: 160px;
    transform: translateY(-50%);
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 103px;
  }
  .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 158px;
  }
  .ssy3{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 214px;
  }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top:208px;
    display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 265px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 321px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 376px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 432px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 488px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 544px;
    display: none;
  }
}
}
@media screen and (max-width: 500px) and (min-width:415px) {
        .swiperss{
            width: 100px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 18px;
            top: 316px;
            z-index: 1999;
        }
        .swipersst{
            width: 20px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 18px;
            top: 316px;
            z-index: 1999;
        }
.header-navbar{
  width: 100%;
  height: 58px;
  background-color: #262626;
  position: relative;
  left: 0;
  top: 0;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  // background-color: rgb(23, 21, 21);
  // opacity: 0.5;
  background-color: #fff;
  color: white;
  position: absolute;
  /* right: 150px; */
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia{
    position: absolute;
    right: 20px;
    top: 144px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 144px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 101px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 154px;
  }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 203px;
        display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 258px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 310px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 365px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 420px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 476px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 531px;
    display: none;
  }
}
}
</style>
